import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
const Termscondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      {/* home */}

      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b>-boost your SEO game&nbsp;&nbsp; <Button size="sm" variant="success">Know More</Button>
          </p>
        </div> */}
        <Nav />
      </div>
      {/* start */}
     
        <div className="mt-md-5 mt-3">
          <div className="row  mx-md-0 mx-3  mt-sm-3">
            <div className="col-md-1 "></div>
            <div className="col m-0 p-0">
              <div>
                <h1  style={{  color: "#090040", justifyContent:"center", display:"flex" }}>
                  SeoBix — Terms & Conditions
                </h1>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  Welcome to SeoBix
                </h2>
                <p>
                  By accessing or using our website and services you agree to
                  comply with and be bound by these Terms and Conditions. If you
                  do not agree with any part of these terms, please do not use
                  our website or services. These terms apply to all visitors,
                  users and others who access or use the SeoBix ( Powered by BUMPPY MEDIA PRIVATE LIMITED ) platform.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  Services
                </h2>
                <p>
                  SeoBix ( Powered by BUMPPY MEDIA PRIVATE LIMITED ) provides digital marketing, SEO services, software
                  solutions and related tools. While we strive to offer
                  accurate, updated and helpful information, we do not guarantee
                  specific results or outcomes from the use of our services. All
                  services are subject to availability and may change without
                  prior notice.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  User Responsibilities
                </h2>
                <p>
                  As a user of SeoBix, you agree to provide accurate and
                  truthful information when creating accounts or using our
                  services. You also agree to use the website and services only
                  for lawful purposes and avoid activities that may harm,
                  disrupt or interfere with SeoBix or other users. You are
                  solely responsible for any content you submit or share on the
                  platform.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  Intellectual Property
                </h2>
                <p>
                  All content on SeoBix, including text, graphics, logos,
                  images, software and data is the property of SeoBix or its
                  licensors and is protected by copyright, trademark and other
                  intellectual property laws. Users may not copy, reproduce,
                  distribute or create derivative works without prior written
                  consent from SeoBix.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  Disclaimer & Liability
                </h2>
                <p>
                  SeoBix provides its services as is and does not guarantee the
                  accuracy, completeness or reliability of any content or
                  services. We are not liable for any direct, indirect,
                  incidental or consequential damages arising from your use of
                  the website or services, including any loss of data, revenue
                  or profits.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  Third-Party Links
                </h2>
                <p>
                  SeoBix may contain links to third party websites or services.
                  We do not control, endorse or assume responsibility for the
                  content, privacy policies or practices of any third party
                  websites. Accessing third party links is at your own risk.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>Privacy</h2>
                <p>
                  Your use of SeoBix is also governed by our Privacy Policy. By
                  using our services, you consent to the collection, storage and
                  use of your data as described in our Privacy Policy. SeoBix
                  reserves the right to suspend or terminate your access to the
                  website or services at any time without prior notice for
                  violation of these Terms and Conditions or any applicable
                  laws.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                  Changes to Terms
                </h2>
                <p>
                  SeoBix may update or modify these Terms and Conditions at any
                  time. Changes will be effective immediately upon posting on
                  the website and your continued use of the platform constitutes
                  acceptance of the updated terms. These Terms and Conditions
                  are governed by and construed in accordance with the laws of
                  India and any disputes arising from your use of SeoBix shall
                  be subject to the exclusive jurisdiction of the courts in
                  Delhi, India.
                </p>

                <h2 style={{ marginTop: "1rem", color: "#090040" }}>Contact</h2>
                <p>
                  If you have any questions or concerns regarding these Terms
                  and Conditions, please contact us at{" "}
                  <a href="mailto:support@seobix.com">support@seobix.com</a> or
                  visit our website at{" "}
                  <a
                    href="https://seobix.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://seobix.com
                  </a>
                  .
                </p>
              </div>
            </div>

            <div className="col-md-1"></div>
          </div>
        </div>
    
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Termscondition;
